import { render } from "./sjsc.vue?vue&type=template&id=bd0def14&scoped=true"
import script from "./sjsc.vue?vue&type=script&lang=js"
export * from "./sjsc.vue?vue&type=script&lang=js"

import "./sjsc.vue?vue&type=style&index=0&id=bd0def14&scoped=true&lang=css"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0def14"]])

export default __exports__